import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import './style.scss'

export const confirmDailog = (props: any) => {

    const messageTemplate = () => {
        return (
            <div className='messageTemplatebody'>
                <p>
                    {props.message}
                </p>
                <p>{props.confirmmessage}</p>
            </div>
        );
    };
    let buttons = [{
        label: props.buttonLabel.yes,
        title: props.buttonLabel.yes,
        onClick: props.yesOnclick,
    }];
    if (!props.hideNoButton) {
        let noButton = {
            label: props.buttonLabel.no,
            title: props.buttonLabel.no,
            onClick: props.noOnclick
        };
        buttons = [...buttons, noButton];
    }
    confirmAlert({
        title: props.title,
        overlayClassName: "overlay-custom-class-name " + props?.className,
        closeOnEscape: false,
        message: messageTemplate() as any,
        buttons: buttons,
        closeOnClickOutside: false,
        keyCodeForClose: [8, 32],
    });

};

export const confirmDailogInfo = (props: any) => {

    const messageTemplate = () => {
        return (
            <div className='messageTemplatebody'>
                <p>
                    {props.message}
                </p>
                <p>{props.confirmmessage}</p>
            </div>
        );
    };
    confirmAlert({
        title: props.title,
        overlayClassName: "overlay-custom-class-name",
        closeOnEscape: false,
        message: messageTemplate() as any,
        buttons: [
            {
                label: props.buttonLabel.yes,
                title: props.buttonLabel.yes,
                onClick: props.yesOnclick,
            }
        ],
        closeOnClickOutside: false,
        keyCodeForClose: [8, 32],
    });

};
